import React from "react";
import { PageShell } from "../components/PageShell";
export function Contact() {
  return <PageShell title="Contact" intro="Une question sur l'événement, la presse ou un partenariat ? Écrivez à l'association." data-id="element-183" data-mp="1bscberd8lz51" />;
}